export const content = {
  ar: {
    project_name: "شفاء",
    language: "ar",
    direction: "rtl",
    logo: "logo.jpeg",
    colors: {
      primary: "#05668D",
      secondary: "#028090",
      accent: "#00A896",
      success: "#02C39A",
      highlight: "#F0F3BD"
    },
    header: {
      title: "نظام شفاء للمستشفيات",
      subtitle: "حل شامل لإدارة جميع أقسام المستشفى الطبية والإدارية"
    },
    hero_section: {
      headline: "نظام معلومات صحي متكامل",
      subheadline: "يربط أقسام المستشفى بكفاءة وشفافية عالية لتحسين جودة الرعاية الصحية",
      call_to_action: {
        text: "اطلب عرضًا توضيحيًا",
        link: "#request-demo"
      },
      image: "logo.jpeg"
    },
    vision: {
      vision_title: "رؤية نظام شفاء",
      statement: "نطمح في نظام شفاء إلى إحداث نقلة نوعية في إدارة الرعاية الصحية الرقمية عبر تمكين المستشفيات من الاعتماد على منصة ذكية وشاملة توفر تكاملًا سلسًا بين الخدمات الطبية والإدارية، مما يضمن تحسين جودة الرعاية وسرعة الاستجابة واتخاذ القرار المبني على البيانات.",
      goals: [
        {
          title: "تحسين جودة الخدمة الطبية",
          description: "من خلال توثيق دقيق وتكامل فوري بين الأطباء، التمريض، المختبرات، الأشعة والصيدلية في واجهة موحدة."
        },
        {
          title: "تسريع العمليات وتقليل الأخطاء",
          description: "أتمتة المسارات العلاجية والروتينية الإدارية لتقليل التكرار اليدوي وتحقيق دقة عالية في كل خطوة."
        },
        {
          title: "التحول نحو مستشفى ذكي",
          description: "لوحات معلومات لحظية، تنبيهات تنبؤية، وربط مباشر بالأجهزة الطبية تساهم في اتخاذ قرارات أسرع وأكثر فاعلية."
        },
        {
          title: "تكامل آمن وشامل",
          description: "دعم كامل لمعايير FHIR وHL7 وتوافق مع الأنظمة التأمينية والحكومية، يضمن استمرارية الخدمة وسهولة التوسع."
        },
        {
          title: "تجربة مستخدم متطورة",
          description: "شاشات تفاعلية حسب الدور الوظيفي، مصممة بعناية لتلائم الأطباء، التمريض، الإداريين، والمختصين الفنيين."
        }
      ],
      design_values: {
        logo_meaning: "يرمز الشعار إلى العناية النابضة بالحياة من خلال رسم سماعة الطبيب متصلة بموجة نبض، مما يعكس القيمة الإنسانية والتقنية للنظام.",
        color_palette: [
          { color: "#05668D", description: "الاحترافية والهدوء التنظيمي" },
          { color: "#028090", description: "الوضوح والابتكار الرقمي" },
          { color: "#00A896", description: "الصحة والنمو" },
          { color: "#02C39A", description: "الشفاء والحيوية" },
          { color: "#F0F3BD", description: "التوازن والراحة البصرية" }
        ]
      },
      slogan: "شفاء.. لأن الرعاية تبدأ بالنظام."
    },
    features: [
      {
        id: "dashboard",
        title: "لوحة القيادة الذكية",
        icon: "FaChartLine",
        description: "لوحة تحكم مركزية تُمكّنك من مراقبة جميع مؤشرات الأداء في المستشفى بلحظة واحدة. تتضمن رسومات بيانية مباشرة لحالات الدخول والخروج، إشغال الأسرة، حالات الطوارئ، تقارير الأداء السريري، مع نظام تنبيهات ذكي يعرض الحالات الحرجة والمخالفات الإجرائية.",
        highlights: [
          "عرض فوري للحالة التشغيلية",
          "تنبيهات بالألوان للحالات الخطرة",
          "مؤشرات أداء تفاعلية لكل قسم"
        ]
      },
      {
        id: "emergency",
        title: "نظام الطوارئ",
        icon: "FaAmbulance",
        description: "نظام استجابة فورية للحالات الحرجة، يدعم تصنيف الحالة (Triage)، وتوجيهها تلقائيًا إلى العيادة أو الطبيب المختص. يتكامل مع شاشات مراقبة العلامات الحيوية، ويوثق الإجراءات الطبية والتمريضية بدقة لحظة بلحظة.",
        highlights: [
          "تصنيف فوري للحالات حسب الأولوية",
          "ربط مباشر مع أجهزة المراقبة الحيوية",
          "توثيق التدخلات بتوقيع إلكتروني"
        ]
      },
      {
        id: "outpatient",
        title: "العيادات الخارجية",
        icon: "FaHospital",
        description: "إدارة متكاملة لمواعيد العيادات، بداية من تسجيل المريض وحتى إصدار الوصفة الطبية. يتمتع النظام بواجهة مرنة لإدخال التاريخ المرضي، الفحص السريري، اقتراح تشخيصات، وتحويل الحالات.",
        highlights: [
          "تنظيم إلكتروني للمواعيد وسجلات المرضى",
          "وصف دوائي مرتبط بتاريخ المريض",
          "سهولة التواصل بين العيادة والمختبرات والأشعة"
        ]
      },
      {
        id: "inpatient",
        title: "نظام التنويم الداخلي",
        icon: "FaBed",
        description: "يتيح متابعة دقيقة للمريض المنوّم، يشمل إدخال الأوامر الطبية، ربط مباشر مع التمريض، تسجيل العلامات الحيوية أوتوماتيكيًا، وإدارة الخطة العلاجية بشكل تفاعلي بين الفريق الطبي.",
        highlights: [
          "متابعة لحظية لحالة المريض",
          "إدارة أوامر طبية إلكترونية",
          "سجل تراكمي موحد من مختلف الأقسام"
        ]
      },
      {
        id: "nursing",
        title: "لوحة التمريض",
        icon: "FaUserNurse",
        description: "لوحة تفاعلية تسهّل على طاقم التمريض تنفيذ المهام اليومية، من إعطاء الأدوية وتسجيل الملاحظات إلى تنفيذ أوامر الطبيب. تحتوي على ميزة التسليم بين المناوبات والتوقيع الإلكتروني.",
        highlights: [
          "عرض المهام اليومية بوضوح",
          "توثيق الأدوية والعلامات الحيوية",
          "ربط مباشر بأوامر الطبيب وتنبيهات الحالة"
        ]
      },
      {
        id: "labs",
        title: "نظام المختبرات",
        icon: "FaFlask",
        description: "نظام طلب الفحوصات المخبرية إلكترونيًا مع تتبع العينة حتى ظهور النتائج. يُمكن للأطباء مشاهدة النتائج فور صدورها مرفقة بالتحليل الزمني لحالة المريض.",
        highlights: [
          "طلب تحاليل وربطها آليًا بالمريض",
          "تحليل بياني للتغيرات الزمنية",
          "نظام تنبيه عند القيم الخطرة"
        ]
      },
      {
        id: "radiology",
        title: "نظام الأشعة",
        icon: "FaXRay",
        description: "إرسال واستقبال طلبات التصوير الشعاعي بمختلف أنواعه (X-ray, CT, MRI). يتيح عرض الصور داخل النظام باستخدام مشغلات DICOM مدمجة، مع تعليقات الطبيب وتشخيصه.",
        highlights: [
          "عرض صور الأشعة بجودة عالية داخل الملف الطبي",
          "تشخيص عن بعد وربط الصور بالتقارير",
          "أرشفة الصور ومشاركتها بسهولة"
        ]
      },
      {
        id: "surgery",
        title: "نظام العمليات الجراحية",
        icon: "FaTools",
        description: "إدارة متكاملة للعمل الجراحي تشمل الحجز، الفريق الجراحي، التهيئة، وإدخال تفاصيل الجراحة. توثيق كامل لكل خطوة داخل غرفة العمليات، ما قبل وما بعد الجراحة.",
        highlights: [
          "جدولة دقيقة للحجوزات",
          "توثيق إلكتروني لتفاصيل العملية",
          "تحليل أداء الجراحين والإجراءات"
        ]
      },
      {
        id: "pharmacy",
        title: "نظام الصيدلية",
        icon: "FaPills",
        description: "نظام ذكي لصرف الأدوية بناءً على الوصفات الطبية الإلكترونية، يرتبط بالمخازن، يتحقق من الكميات المتوفرة، ويمنع صرف الأدوية المتعارضة.",
        highlights: [
          "صرف آمن وسريع للأدوية",
          "تحقق من التداخلات والحساسية",
          "إدارة دقيقة لمخزون الصيدلية"
        ]
      },
      {
        id: "administration",
        title: "الأنظمة الإدارية والمساندة",
        icon: "FaBriefcase",
        description: "تشمل الموارد البشرية، إدارة الجرد والمشتريات، المالية، التأمين الطبي، ونظام الفوترة. تساعد في تحسين التشغيل الإداري وتقليل التكاليف.",
        highlights: [
          "تتبع دقيق للنفقات والإيرادات",
          "أرشفة إلكترونية للموارد",
          "إدارة العقود وجدولة القوى العاملة"
        ]
      },
      {
        id: "integration",
        title: "الربط والتكامل",
        icon: "FaLink",
        description: "تكامل سهل وآمن مع الأنظمة الحكومية والتأمينية عبر HL7 وFHIR، ودعم الربط مع أجهزة الأشعة والتحاليل والمراقبة الحيوية.",
        highlights: [
          "توافق مع معايير عالمية (HL7, FHIR)",
          "ربط آمن مع الأجهزة الطبية",
          "دعم التبليغ الإلكتروني للجهات المختصة"
        ]
      }
    ],
    contact: {
      title: "تواصل معنا",
      email: "info@zonecoder.ps",
      phone: "+972567823262",
      website: "https://zonecoder.ps",
      whatsapp: "+972567823262"
    },
    footer: {
      text: "© 2025 جميع الحقوق محفوظة - شركة ZoneCoder",
      social: ["facebook", "twitter", "linkedin"]
    }
  },
  en: {
    project_name: "Shifaa",
    language: "en",
    direction: "ltr",
    logo: "logo.jpeg",
    colors: {
      primary: "#05668D",
      secondary: "#028090",
      accent: "#00A896",
      success: "#02C39A",
      highlight: "#F0F3BD"
    },
    header: {
      title: "Shifaa Hospital Management System",
      subtitle: "A comprehensive solution for managing all hospital medical and administrative departments"
    },
    hero_section: {
      headline: "Integrated Health Information System",
      subheadline: "Connects hospital departments efficiently and transparently to improve healthcare quality",
      call_to_action: {
        text: "Request a Demo",
        link: "#request-demo"
      },
      image: "logo.jpeg"
    },
    vision: {
      vision_title: "Shifaa Vision",
      statement: "Our vision is to revolutionize healthcare management by enabling hospitals to rely on a comprehensive, integrated platform that provides seamless integration between medical services and administrative functions, ensuring improved healthcare quality, faster response, and decision-making based on data.",
      goals: [
        {
          title: "Improving Healthcare Service Quality",
          description: "Through precise documentation and real-time integration between doctors, nurses, laboratories, radiology, and pharmacy in a unified interface."
        },
        {
          title: "Accelerating Processes and Reducing Errors",
          description: "Automating administrative and routine treatment pathways to reduce manual repetition and achieve high accuracy at each step."
        },
        {
          title: "Transition to a Smart Hospital",
          description: "Real-time information panels, predictive alerts, and direct connections to medical devices contribute to faster and more effective decision-making."
        },
        {
          title: "Secure and Comprehensive Integration",
          description: "Full support for FHIR and HL7 standards and compatibility with government and insurance systems, ensuring service continuity and ease of expansion."
        },
        {
          title: "Advanced User Experience",
          description: "Interactive screens designed with care for doctors, nurses, administrative staff, and technical staff."
        }
      ],
      design_values: {
        logo_meaning: "The logo represents the attentive and nurturing aspect of life through the drawing of a stethoscope connected to a pulse wave, reflecting the human and technical value of the system.",
        color_palette: [
          { color: "#05668D", description: "Professionalism and Organizational Calmness" },
          { color: "#028090", description: "Clarity and Digital Innovation" },
          { color: "#00A896", description: "Health and Growth" },
          { color: "#02C39A", description: "Healing and Vitality" },
          { color: "#F0F3BD", description: "Balance and Visual Comfort" }
        ]
      },
      slogan: "Shifaa... Because Care Starts with the System."
    },
    features: [
      {
        id: "dashboard",
        title: "Smart Dashboard",
        icon: "FaChartLine",
        description: "A central platform for real-time hospital status monitoring through graphical indicators and performance metrics.",
        highlights: [
          "Display of current and admitted patients count",
          "Bed occupancy and congestion indicator",
          "Emergency department response rate",
          "Interactive daily/weekly reports",
          "Color-coded alerts for critical levels",
          "Customizable dashboard for each role (doctor, nurse, manager)"
        ]
      },
      {
        id: "emergency",
        title: "Emergency System",
        icon: "FaAmbulance",
        description: "Instant system for managing emergency and critical cases from the moment the patient arrives.",
        highlights: [
          "Automatic triage support",
          "Direct integration with vital sign monitors",
          "Real-time admission and nursing procedures logging",
          "Automatic routing to the on-call doctor",
          "Instant notifications for relevant teams by case severity",
          "Digital signature logging by nurse and doctor"
        ]
      },
      {
        id: "outpatient",
        title: "Outpatient Clinics",
        icon: "FaHospital",
        description: "Comprehensive system for organizing clinic visits, appointment scheduling, and medical documentation.",
        highlights: [
          "Flexible, multi-doctor appointment scheduling",
          "Comprehensive patient record including medical history",
          "Clinical examination entry with AI diagnostic suggestions",
          "Ability to request radiology and lab tests from the clinic",
          "Direct integration with pharmacy for prescriptions"
        ]
      },
      {
        id: "inpatient",
        title: "Inpatient Management",
        icon: "FaBed",
        description: "Continuous monitoring of inpatients across hospital departments.",
        highlights: [
          "Assigning a medical team to each patient",
          "Electronic doctor order entry",
          "24/7 vital sign tracking",
          "Timeline for treatment plan",
          "Monitoring nutrition and nursing care"
        ]
      },
      {
        id: "nursing",
        title: "Nursing",
        icon: "FaUserNurse",
        description: "A screen designed to support nursing teams in performing their tasks.",
        highlights: [
          "Daily task list for each patient",
          "Medication administration schedule tracking",
          "Ability to record vital signs",
          "Shift handover and previous nurse notes",
          "Case documentation with digital signature"
        ]
      },
      {
        id: "labs",
        title: "Laboratory System (LIS)",
        icon: "FaFlask",
        description: "Efficient tool for managing lab test requests and linking results to the medical record.",
        highlights: [
          "Electronic test requests linked to the patient",
          "Sample tracking from receipt to analysis",
          "Automatic result display in the patient file",
          "Graphical support for monitoring value changes over time"
        ]
      },
      {
        id: "radiology",
        title: "Radiology System",
        icon: "FaXRay",
        description: "Management of radiology requests and review of reports and images within the system.",
        highlights: [
          "Send requests for various radiology types",
          "DICOM-quality image viewing within the system",
          "Radiologist comment capability",
          "Automatic report linking to the medical file"
        ]
      },
      {
        id: "surgery",
        title: "Surgery Management",
        icon: "FaTools",
        description: "Integrated system for managing preparations, execution, and documentation of surgeries.",
        highlights: [
          "Accurate scheduling for surgeons and operating rooms",
          "Pre-surgery checklist review",
          "Step-by-step surgical procedure entry",
          "Comprehensive post-surgery report with digital signature"
        ]
      },
      {
        id: "pharmacy",
        title: "Pharmacy",
        icon: "FaPills",
        description: "Medication dispensing and inventory updates automatically based on e-prescriptions.",
        highlights: [
          "Direct integration with prescriptions",
          "Drug interaction and allergy checking",
          "Medication dispensing tracking for each patient",
          "Inventory and shortage reports"
        ]
      },
      {
        id: "administration",
        title: "Admin Systems",
        icon: "FaBriefcase",
        description: "Management of resources, finances, and logistics operations.",
        highlights: [
          "HR and attendance management",
          "Purchasing and inventory tracking",
          "Medical billing and insurance system",
          "Detailed financial reports"
        ]
      },
      {
        id: "integration",
        title: "Integration",
        icon: "FaLink",
        description: "Integration interfaces with systems and medical devices.",
        highlights: [
          "HL7 and FHIR support",
          "Integration with lab and radiology devices",
          "Integration with government and insurance systems",
          "API interfaces for third-party applications"
        ]
      }
    ],
    contact: {
      title: "Contact Us",
      email: "info@zonecoder.ps",
      phone: "+972567823262",
      website: "https://zonecoder.ps",
      whatsapp: "+972567823262"
    },
    footer: {
      text: "© 2025 All Rights Reserved - ZoneCoder Company"
    }
  }
}; 